import { useState } from 'react';

const RenderAvatar = ({ candidate }) => {
  const [loaded, setLoaded] = useState(true);

  return (
    <>
      {loaded ? (
        <img
          src={candidate.avatarUrl}
          alt={candidate.name}
          onError={() => setLoaded(false)}
          onLoad={() => setLoaded(true)}
        />
      ) : candidate.isWoman === true ? (
        <img src="/img/user-woman.png" alt="woman" />
      ) : (
        <img src="/img/user-man.png" alt="man" />
      )}
    </>
  );
};

export default RenderAvatar;